import { Link } from 'react-router-dom';
import { cn } from '../ui/cn';
import { PortalIdentity } from './PortalIdentity';

/**
 * Portal wordmark (PRO-0340 / ADR-014 Amendment 1). The tier-0 identity in the
 * application banner — distinct from route headings inside `main`. Links to Home;
 * the icon is decorative (`aria-hidden`); the link name is the full portal title.
 */
export function PortalWordmark({
  className,
  compact = false,
}: {
  className?: string;
  /** Mobile header: smaller mark, no subtitle — saves horizontal space (PRO-0540). */
  compact?: boolean;
}) {
  return (
    <Link
      to="/"
      className={cn(
        'group inline-flex min-h-11 max-w-full items-center gap-3 rounded-md no-underline',
        'outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        className,
      )}
      aria-label="TAG Operations — The Aurora Group portal home"
    >
      <PortalIdentity
        compact={compact}
        iconClassName={cn(
          'motion-safe:transition-[background-color,box-shadow] motion-safe:duration-[var(--transition-fast)] motion-safe:ease-ds',
          'motion-safe:group-hover:bg-primary-hover motion-safe:group-hover:shadow-md',
        )}
      />
    </Link>
  );
}
